// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"general_sectionTitle__3YGeO"};